import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchHistogramConfig = async ({ trialId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/ecrf/trial/${trialId}/histogram-config/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetHistogramConfig = ({ trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["histogram_config", trialId],
    queryFn: () => fetchHistogramConfig({ trialId }),
    enabled: enabled && Boolean(trialId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load histogram configuration");
    },
  });
};

export default useGetHistogramConfig;
